<div class="flex flex-col  w-full ">

    <app-banner_section-type01
        [options]="{title:'' ,imageHref:'assets/images/xl-travel-banners/XL_WEB_PAGE_BANNERS_1.jpg?'}"></app-banner_section-type01>
    <!-- <div>
        <div class="w-full mx-auto sm:px-6 pt-8 pb-16 grid md:grid-cols-2 lg:grid-cols-2 gap-y-8 lg:gap-x-8 lg:gap-y-16">
            <div>
                <div class="p-4 rounded-3xl">
                    <div class="flex flex-col">
                        @if (view.site && view.site.profile && view.site.profile.heading) {
                        @switch (view.site.profile.heading.banner) {
                        @case (1) {
                        <app-heading_section-type01
                            [options]="{heading:view.page?.content.name,title:'Our XL Travel Offices Across Southern Africa',image:'', description:'',swooshAlign: {'margin':''} }"></app-heading_section-type01>
                        }
                        @case (2) {
                        <app-heading_section-type01
                            [options]="{heading:'',title:'Our XL Travel Offices Across Southern Africa',image:'', description:''}"></app-heading_section-type01>
                        }
                        }
                        }
                    </div>
                </div>
                <div>
                    <p class="px-4 pb-10 text-justify">Discover a range of travel services offered by our XL Travel Offices
                        located
                        in various regions, including Gauteng, Western Cape, KZN, Free State, Northern Cape, Eastern Cape,
                        Mpumalanga, North West, and neighboring countries like Lesotho, Namibia, and Swaziland. Whether you're
                        planning a getaway or seeking local travel expertise, our partners, including XL Fairmount World Travel
                        and
                        City of Choice Travel & Tours, are here to assist you. Start your journey with us today!</p>
                </div>
            </div>
            <div class=" w-[100%] ">
                <iframe width="100%" height="100%" src="https://www.youtube.com/embed/yaNvvzQNT-8" title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowfullscreen>
                </iframe>
            </div>
        </div>
    </div> -->
    <div class="p-10 m-auto">
        <label class="inline-flex items-center text-center p-2" *ngFor="let region of regionList">
            <input type="checkbox" class="form-checkbox w-4 h-4 text-blue-600"
                [checked]="selectedRegions.includes(region)"
                (change)="onRegionChange(region, $event)" />
            <span class="ml-2">
                {{ region }}
            </span>
        </label>
    </div>

    <div class="p-4">
        <form class="flex items-center gap-2 max-w-md mx-auto">
            <label for="simple-search" class="sr-only">Search</label>
            <div class="relative flex-1">
                <input type="text" id="simple-search"
                    [(ngModel)]="searchQuery"
                    name="memberSearch"
                    (ngModelChange)="onSearchInput($event)"
                    (focus)="showSuggestions = searchQuery.length > 0"
                    (blur)="hideSuggestionsLater()"
                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-accent-500 block w-full ps-10 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                    placeholder="Search member or location..." />
                <div *ngIf="showSuggestions && searchSuggestions.length > 0"
                    class="absolute left-0 right-0 top-full z-20 mt-1 max-h-72 overflow-y-auto rounded-lg border border-gray-200 bg-white py-1 shadow-lg dark:border-gray-600 dark:bg-gray-800">
                    <button type="button"
                        *ngFor="let card of searchSuggestions"
                        (mousedown)="$event.preventDefault()"
                        (click)="selectSuggestion(card)"
                        class="flex w-full flex-col px-4 py-2.5 text-left text-sm hover:bg-gray-100 focus:bg-gray-100 focus:outline-none dark:hover:bg-gray-700 dark:focus:bg-gray-700">
                        <span class="font-medium text-gray-900 dark:text-white">{{ card.name }}</span>
                        <span *ngIf="card.details?.[0]?.address" class="mt-0.5 truncate text-gray-500 dark:text-gray-400">{{ card.details[0].address }}</span>
                    </button>
                </div>
            </div>
            <button type="button"
                (click)="resetFilters()"
                class="shrink-0 rounded-lg border border-gray-300 bg-white px-4 py-2.5 text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600">
                Reset
            </button>
        </form>
    </div>
    <div class="pt-10 relative h-[550px] overflow-hidden  w-full">
        <!-- <app-map-type01 ></app-map-type01> -->
        <app-map-type01 [locations]="view.locations" [defaultLat]="view.defaultLat"
            [defaultLng]="view.defaultLng" [bounds]="view.mapBounds"></app-map-type01>
    </div>
    <ng-container *ngIf="view.filteredCardDataList && view.filteredCardDataList.length > 0">
    <div class="grid lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-4 p-2 md:p-8 lg:p-15">
        <div *ngFor="let card of view.filteredCardDataList">
            <!-- <div *ngFor="let card of cardDataList"> -->
            <fuse-card class="flex flex-col" [flippable]="true" #fuseCard>
                <!-- Front -->
                <ng-container fuseCardFront>
                    <div class="flex flex-col h-36 justify-center items-center px-3 sm:h- pb-3 cursor-pointer"
                        (click)="fuseCard.face = 'back'">
                        <div class=" ">
                            <div class="h-24 mb-2 flex items-center justify-center max-w-72">
                                <img [src]="card?.logoUrl || 'assets/images/logo/avatar-default'"
                                    [alt]="card?.name + 'Logo'" class="object-cover w-full p-2">
                            </div>
                            <!-- <img src="assets/images/logo/avatar-default" [alt]="card.name + ' Logo'"> -->
                            <!-- <div class="h-14">
                                    <p class="font-secondary text-lg text-center tracking-wide text-gray-400 line-clamp-2">card name</p>
                                </div> -->
                        </div>
                        <div class="flex items-center justify-center self-end w-15  cursor-pointer">
                            <button mat-icon-button>
                                <mat-icon class="icon-size-6 text-accent-500 rounded-full ring-2 ring-accent-500"
                                    [svgIcon]="'heroicons_outline:arrow-right'"></mat-icon>
                            </button>
                        </div>
                    </div>
                </ng-container>
                <!-- Back -->
                <ng-container fuseCardBack>
                    <div class="flex flex-col flex-auto px-8 pt-3 cursor-pointer" (click)="fuseCard.face = 'front'">
                        <div class="-mx-3">
                            <button mat-icon-button>
                                <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:arrow-left'"></mat-icon>
                            </button>
                        </div>
                        <div class="w-full justify-center items-center">
                            <div class="my-2" *ngFor="let location of card?.details">
                                <p *ngIf="location.address" class="text-secondary text-md">{{ location.address }}</p>
                                <p *ngIf="location.phone" class="text-secondary text-md mb-2"><span
                                        class="text-secondary font-bold">Tel : </span>{{location.phone}}</p>
                                <hr *ngIf="location.phone && location.address">
                            </div>
                            <div class="flex justify-center w-full">
                                <a [href]="card?.url" target="_blank"
                                    class="text-secondary text-xl cursor-pointer hover:underline duration-500">{{ card?.urlName }}</a>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </fuse-card>
        </div>
    </div>
    </ng-container>
    <div *ngIf="!view.filteredCardDataList || view.filteredCardDataList.length === 0" class=" min-h-72 text-center text-gray-500 mt-8 w-full">
        <p class="text-center">No results found</p>
    </div>
</div>